import { useEffect } from "react";
import { FieldValues, UseFormSetError } from "react-hook-form";
import { AxiosError } from "axios";
import { ApiValidationError } from "../../models/ApiValidationError";
import applyApiValidationErrors from "../../helpers/applyApiValidationErrors"; // 👈 import the helper

export function useApiFieldErrors<T extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<T>
) {
  useEffect(() => {
    if (error && typeof error === "object" && "isAxiosError" in error) {
      applyApiValidationErrors<T>(
        error as AxiosError<ApiValidationError>,
        setError
      );
    }
  }, [error, setError]);
}
